<div class="cx-modal-container">
    <div class="cx-modal-content">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          @if(mergeComponentData?.cartType === 'BUY_CART'){
            <span>{{ "savedCart.mergeBuyCart" | cxTranslate }}</span>
          } @else if(mergeComponentData?.cartType === 'QUOTE_CART'){
            <span>{{ "savedCart.mergeQuoteCart" | cxTranslate }}</span>
          }
        </div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="closeModal('close')"
        >
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="cx-dialog-body modal-body">
        <div class="row">
          <div class="cx-dialog-info col-md-12">
            <p>
              @if(mergeComponentData?.cartType === 'BUY_CART'){
                <b>
                  {{ "savedCart.mergeBuyCartsCheckout" | cxTranslate }}
                </b>
              } @else if(mergeComponentData?.cartType === 'QUOTE_CART'){
                <b>
                  {{ "savedCart.mergeQuoteCartsCheckout" | cxTranslate }}
                </b>
              }
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-md-6 merge-container">
            <button class="vs-text-btn" (click)="closeModal('merge-checkout-cart')">
              <i class="material-icons">merge</i>
              <span> {{ "savedCart.mergeBtn" | cxTranslate }} </span>
            </button>
          </div>
          <div class="col-sm-4 col-md-4 no-merge-container">
            <button cxAutoFocus class="vs-primary-btn" (click)="closeModal('no-merge-checkout-cart')">
              <i class="material-icons">cancel_presentation</i>
              {{ "savedCart.noMergeBtn" | cxTranslate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  